import { render, staticRenderFns } from "./GyDivider.vue?vue&type=template&id=448085ab&"
import script from "./GyDivider.vue?vue&type=script&lang=js&"
export * from "./GyDivider.vue?vue&type=script&lang=js&"
import style0 from "./GyDivider.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports